import { TwButton, TwButtonType } from '../TwButtons/TwButtons';
import TwDialog from '../TwDialog/TwDialog';
import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import React, { FC, ReactNode } from 'react';

interface TwLeaveWarningProps {
  isOpenWarning: boolean;
  handleClose: () => void;
  closeWarning: () => void;
  saveAndContinue: () => void;
  title?: string;
  warningMessage?: string | React.ReactNode;
  closeLabel?: string;
  saveAndCloseLabel?: string;
}

export const TwLeaveWarning: FC<TwLeaveWarningProps> = ({
  isOpenWarning,
  handleClose,
  saveAndContinue,
  closeWarning,
  title = 'Leave page?',
  warningMessage = 'You haven’t finished reviewing the document. Do you want to leave without finishing?',
  closeLabel = 'Close without saving',
  saveAndCloseLabel = 'Save & close'
}: TwLeaveWarningProps): JSX.Element => {
  return (
    <TwDialog open={isOpenWarning} title={title} onClickClose={closeWarning}>
      <div className="warning">
        <Warning />
        <p className="warning__message">{warningMessage}</p>
        <div className="warning__actions">
          <TwButton
            fullwidth={false}
            label={closeLabel}
            type={TwButtonType.secondary}
            action={handleClose}
          />
          <TwButton
            fullwidth={false}
            label={saveAndCloseLabel}
            type={TwButtonType.primary}
            action={saveAndContinue}
          />
        </div>
      </div>
    </TwDialog>
  );
};
